import React, { useState, useEffect } from 'react';
import UDIRowPopup, { UDIPopupField, UDIAddRowButton, useUDIRowPopup } from './UDIRowPopup.js';

const ProductPackageDI = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.USProductUDI.PackageDI",
    fieldTitle = "Package DI",
    forceIsEditing = null }) => {
    // Parse initial data from Razor (fallback to empty array)
    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch {
            return [];
        }
    });

    // Form State
    const initialFormState = {
        PackageDINumber: '',
        PackageDIQuantity: '',
        PackageDIContains: '',
        PackageDIType: '',
        PackageDIDiscontinuedDate: ''
    };
    const [formData, setFormData] = useState(initialFormState);
    const [editingIndex, setEditingIndex] = useState(null);
    const [errors, setErrors] = useState({});
    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);


    // Handlers
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        // Clear specific error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: false }));
        }
    };

    const handleSave = () => {
        const {
            PackageDINumber,
            PackageDIQuantity,
            PackageDIContains,
            PackageDIType,
            PackageDIDiscontinuedDate
        } = formData;

        let newErrors = {};
        let isValid = true;

        const isNumeric = (str) => /^[0-9]+$/.test(str);
        const isAlphaNum = (str) => /^[A-Za-z0-9]+$/.test(str);

        // Validation
        if (PackageDINumber.length < 6 || PackageDINumber.length > 23 || !isAlphaNum(PackageDINumber)) {
            newErrors.PackageDINumber = true;
            isValid = false;
        }
        if (PackageDIQuantity.length > 9 || !isNumeric(PackageDIQuantity)) {
            newErrors.PackageDIQuantity = true;
            isValid = false;
        }
        if (PackageDIType.length > 20 || !isAlphaNum(PackageDIType)) {
            newErrors.PackageDIType = true;
            isValid = false;
        }
        if (PackageDIDiscontinuedDate.length > 10) {
            newErrors.PackageDIDiscontinuedDate = true;
            isValid = false;
        }

        if (!isValid) {
            setErrors(newErrors);
            return;
        }

        // Save Logic (Update or Add)
        const updatedItems = [...items];
        if (editingIndex !== null) {
            updatedItems[editingIndex] = formData;
        } else {
            updatedItems.push(formData);
        }

        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            PackageDI: updatedItems
        }));

        popup.close();
    };

    const handleEdit = (index) => {
        setFormData(items[index]);
        setEditingIndex(index);
        setErrors({});
        popup.openEdit();
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            PackageDI: updatedItems
        }));

        resetForm();
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setEditingIndex(null);
        setErrors({});
    };

    const popup = useUDIRowPopup(resetForm);



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);




    return (


        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?

                            <>

                                {/* Items Table */}
                                <table id="productUsUDIPackageDI_itemsTable" className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Package DI Number</th>
                                            <th>Quantity per Package</th>
                                            <th>Contains DI Package</th>
                                            <th>Type</th>
                                            <th>Discontinued Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr
                                                key={index}
                                                className={`row_${index} ${editingIndex === index ? 'udi-complex-field-row-selected' : ''}`}
                                            >
                                                <td>{item.PackageDINumber}</td>
                                                <td>{item.PackageDIQuantity}</td>
                                                <td>{item.PackageDIContains}</td>
                                                <td>{item.PackageDIType}</td>
                                                <td>{item.PackageDIDiscontinuedDate}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="udiEditButton"
                                                        onClick={() => handleEdit(index)}
                                                    >
                                                        <i className="fas fa-edit"></i> Edit
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="udiRemoveButton"
                                                        onClick={() => handleRemove(index)}
                                                        style={{ marginLeft: '5px' }}
                                                    >
                                                        <i className="fas fa-times-circle"></i> Remove
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <UDIAddRowButton label="Add Package DI" onClick={popup.openAdd} />

                                <UDIRowPopup
                                    isOpen={popup.isOpen}
                                    title={editingIndex !== null ? "Edit Package DI" : "Add Package DI"}
                                    saveLabel={editingIndex !== null ? "Save" : "Add"}
                                    onClose={popup.close}
                                    onSave={handleSave}
                                >
                                    <div>
                                        Package DI Number <br />
                                        <input
                                            type="text"
                                            name="PackageDINumber"
                                            value={formData.PackageDINumber}
                                            onChange={handleInputChange}
                                            maxLength="23"
                                        />
                                        {errors.PackageDINumber && (
                                            <div className="field-validation-error" style={{ color: 'red' }}>
                                                Field must be alphanumeric and between 6 and 23 characters long
                                            </div>
                                        )}
                                    </div>
                                    <br />

                                    <div>
                                        Quantity per Package <br />
                                        <input
                                            type="text"
                                            name="PackageDIQuantity"
                                            value={formData.PackageDIQuantity}
                                            onChange={handleInputChange}
                                            maxLength="9"
                                        />
                                        {errors.PackageDIQuantity && (
                                            <div className="field-validation-error" style={{ color: 'red' }}>
                                                Field must be numeric and maximum 9 characters long
                                            </div>
                                        )}
                                    </div>
                                    <br />

                                    <div>
                                        Contains DI Package <br />
                                        <input
                                            type="text"
                                            name="PackageDIContains"
                                            value={formData.PackageDIContains}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    <br />

                                    <div>
                                        Package Type <br />
                                        <input
                                            type="text"
                                            name="PackageDIType"
                                            value={formData.PackageDIType}
                                            onChange={handleInputChange}
                                            maxLength="20"
                                        />
                                        {errors.PackageDIType && (
                                            <div className="field-validation-error" style={{ color: 'red' }}>
                                                Field must be alphanumeric and maximum 20 characters long
                                            </div>
                                        )}
                                    </div>
                                    <br />

                                    <div>
                                        Package Discontinue Date <br />
                                        <input
                                            type="date"
                                            name="PackageDIDiscontinuedDate"
                                            value={formData.PackageDIDiscontinuedDate}
                                            onChange={handleInputChange}
                                            maxLength="10"
                                        />
                                        {errors.PackageDIDiscontinuedDate && (
                                            <div className="field-validation-error" style={{ color: 'red' }}>
                                                Field must be a date and 10 characters long
                                            </div>
                                        )}
                                    </div>
                                    <br />
                                </UDIRowPopup>

                                <input type="hidden"
                                    id="productUsUDIPackageDI_field"
                                    name={hiddenFieldName}
                                    value={JSON.stringify(items)}
                                />

                            </>

                            :

                            <>

                                {/* Items Table */}
                                <table id="productUsUDIPackageDI_itemsTable" className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Package DI Number</th>
                                            <th>Quantity per Package</th>
                                            <th>Contains DI Package</th>
                                            <th>Type</th>
                                            <th>Discontinued Date</th>
                                            <th>Package Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => {

                                            const discontinued = item.PackageDIDiscontinuedDate || "";

                                            const PackageDIStatus = discontinued.trim() === ""
                                                ? "In Commercial Distribution"
                                                : "Not in Commercial Distribution";

                                            return (

                                                <tr
                                                    key={index}
                                                    className={`row_${index} ${editingIndex === index ? 'udi-complex-field-row-selected' : ''}`}
                                                >
                                                    <td>{item.PackageDINumber}</td>
                                                    <td>{item.PackageDIQuantity}</td>
                                                    <td>{item.PackageDIContains}</td>
                                                    <td>{item.PackageDIType}</td>
                                                    <td>{item.PackageDIDiscontinuedDate}</td>
                                                    <td>{PackageDIStatus}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>


                                {/*
                                    <input
                                        type="button"
                                        className="udiActionButton"
                                        value="Edit"
                                        onClick={() => changeIsEditingField(true)}
                                    />
                                */}

                            </>

                        }

                    </div>

                </div>
            </div>
        </div>


    );
};

export default ProductPackageDI;